export const pageNames = {
    home: 'Home',
    map: 'Map',
}
